import { render } from "./GoingToRoom.vue?vue&type=template&id=5512a5c5"
import script from "./GoingToRoom.vue?vue&type=script&lang=js"
export * from "./GoingToRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__